import { render } from "./PaymentService.vue?vue&type=template&id=195b95c3&scoped=true"
import script from "./PaymentService.vue?vue&type=script&lang=js"
export * from "./PaymentService.vue?vue&type=script&lang=js"

import "./PaymentService.vue?vue&type=style&index=0&id=195b95c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195b95c3"]])

export default __exports__